import React from 'react';
import { IconProps } from '.';

const SvgColoredTrendIncreasingLine = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#4769F7'
        d='M14.213 14.617a.75.75 0 0 1-1.224.107l-3.075-3.662L3.95 21.393a.75.75 0 1 1-1.3-.75l6.5-11.258a.75.75 0 0 1 1.224-.107l3.075 3.662L17.86 5.3l-3.07.623a.75.75 0 1 1-.298-1.47l4.9-.995a.75.75 0 0 1 .884.585l.995 4.9a.75.75 0 1 1-1.47.299l-.647-3.184-4.941 8.56Z'
      />
    </svg>
  );
};

export default SvgColoredTrendIncreasingLine;
